import { ACCENT_BLUE, EVIL_RED, NOPING_GREEN } from '../constants';

export function HeroGlow() {
  return (
    <div className='pointer-events-none absolute inset-0' aria-hidden='true'>
      <div className='absolute right-0 top-0 size-[60vw] max-h-[800px] max-w-[800px] -translate-y-1/4 translate-x-1/4 rounded-full blur-[150px]' style={{ background: `${NOPING_GREEN}08` }} />
      <div className='absolute bottom-0 left-0 size-[50vw] max-h-[700px] max-w-[700px] -translate-x-1/4 translate-y-1/4 rounded-full blur-[120px]' style={{ background: `${EVIL_RED}0A` }} />
      <div className='absolute left-1/2 top-1/2 size-[70vw] max-h-[900px] max-w-[900px] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[200px]' style={{ background: `${ACCENT_BLUE}05` }} />
      <div
        className='absolute inset-0 opacity-[0.04]'
        style={{
          background: `linear-gradient(135deg, transparent 30%, ${EVIL_RED} 30%, ${EVIL_RED} 30.5%, transparent 30.5%, transparent 60%, ${NOPING_GREEN} 60%, ${NOPING_GREEN} 60.5%, transparent 60.5%)`,
        }}
      />
    </div>
  );
}
